<template>
  <v-dialog v-model="dialogTransferPermission" persistent max-width="900px">
      <v-card>
        <v-card-title>
          <span class="txt-head" style="text-decoration: underline;">โอนสิทธิ์ผู้อนุมัติ</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="row ml-10">
              <v-col cols="2">
                <span class="txt-font">รหัสพนักงาน</span>
              </v-col>
              <v-col cols="4" class="form-control">
                <!-- <v-text-field
                  v-model="dataSearchEmployee"
                  :rules="rulesSearch"
                  v-on:keyup.enter="searchEmployee(dataSearchEmployee)"
                  dense
                  outlined
                ></v-text-field> -->
                <v-autocomplete
                  v-model="dataSearchEmployee"
                  @change="searchEmployee(dataSearchEmployee)"
                  :items="itemUser"
                  item-text="employeeId"
                  item-value="employeeId"
                  :loading="isLoading"
                  :search-input.sync="searchEmpoyee"
                  hide-details
                  hide-selected
                  label="ค้นหา พนักงาน"
                  dense
                  outlined
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        ค้นหาพนักงานโดย
                        <strong>ชื่อสกุล หรือรหัสพนักงาน</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template
                      slot="selection"
                      slot-scope="{ item }"
                    >
                    <span>{{item.employeeId}}</span>
                    </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.employeeId"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
                      <!-- <v-list-item-subtitle v-text="item.position.positionName"></v-list-item-subtitle> -->
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <!-- <v-btn
                color="indigo"
                class="txt-font mr-3"
                @click="searchEmployee(dataSearchEmployee)"
                >
                  ค้นหา
                <v-icon right dark>fa-search</v-icon>
                </v-btn> -->
                <v-btn
                  color="warning"
                  class="create-orgchart-header-cancel-btn"
                  @click="clearSearchEmployee()"
                  >
                    ล้างข้อมูล
                  <v-icon right dark>fa-times</v-icon>
                </v-btn>
              </v-col>
            </v-layout>
            <!-- <OverlayLoading :loading="loading" /> -->
            <v-layout class="row ml-10">
              <v-col cols="2">
                <p class="txt-font" style="margin-top: 1.5%;">ชื่อ-นามสกุล</p>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="fNameTh"
                  readonly
                  dense
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <p class="txt-font" style="margin-top: 1.5%;">บริษัท</p>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="companyName"
                  readonly
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-layout>
            <v-layout class="row ml-10">
              <v-col cols="2">
                <p class="txt-font" style="margin-top: 1.5%;">รหัสพนักงาน</p>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="employeeId"
                  readonly
                  dense
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <p class="txt-font" style="margin-top: 1.5%;">ตำแหน่ง</p>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="position"
                  readonly
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-0 create-orgchart-header-cancel-btn" color="primary" dark @click="closeDialog">ยกเลิก</v-btn>
          <v-btn class="mr-0 create-orgchart-header-cancel-btn" color="success" @click="confirmApprove()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { getUserByKeyword, transferApprover } from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
// import { OverlayLoading } from '@/components/index'
export default {
  components: {
    // TableManageCompany
    // OverlayLoading
  },
  data () {
    return {
      isLoading: false,
      loading: false,
      dialogTransferPermission: false,
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      fNameTh: '',
      lNameTh: '',
      companyName: '',
      employeeId: '',
      position: '',
      dataSearchEmployee: '',
      items: [],
      itemUser: [],
      search: null,
      select: null,
      searchEmpoyee: null,
      userId: '',
      transferUserId: '',
      serviceId: '',
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ]
    }
  },
  mounted () {
    EventBus.$on('openDialogTransferPermission', this.openDialogTransferPermission)
    // EventBus.$on('opendialogAuthorityRequest', this.openDialogApprove)
  },
  created () {
    this.propsEmpId = this.$route.params.id
    this.getUser()
  },
  methods: {
    openDialogTransferPermission (value, userId, serviceId) {
      this.dialogTransferPermission = value
      this.userId = userId
      this.serviceId = serviceId
    },
    closeDialog () {
      this.dialogTransferPermission = false
      this.dataSearchEmployee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.companyName = ''
    },
    clearSearchEmployee () {
      this.dataSearchEmployee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.companyName = ''
    },
    async getUser () {
      this.loading = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          temp = res.result
          this.itemUser = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async searchEmployee (value) {
      this.loading = true
      const obj = {
        search: value
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        // console.log('Select User', res.result[0])
        if (res.result) {
          this.fNameTh = res.result[0].name
          this.lNameTh = res.result[0].name
          this.employeeId = res.result[0].employeeId
          this.position = res.result[0].position.positionName
          this.companyName = res.result[0].companyName
          this.transferUserId = res.result[0].id
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.loading = false
      }
    },
    async confirmApprove () {
      swal('ต้องการโอนย้ายสิทธิ์ ใช่หรือไม่?', `โอนสิทธิ์ให้ : ${this.fNameTh}`, 'warning', {
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      }).then(async (confirm) => {
        if (confirm) {
          this.loading = true
          const obj = {
            serviceId: this.serviceId,
            userId: this.transferUserId
          }
          // console.log('OBJ', obj)
          try {
            const res = await transferApprover(obj, this.$store.state.token)
            // console.log('Response Approver', res)
            if (res.success) {
              swal('สำเร็จ', 'โอนย้ายสิทธิ์ สำเร็จ', 'success', {
                button: false,
                timer: 2000
              })
              this.dialogTransferPermission = false
            }
          } catch (error) {
            swal('Error', 'โอนย้ายสิทธิ์ ไม่สำเร็จ!', 'error')
            console.log(error)
          } finally {
            this.loading = false
          }
        }
      }
      )
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
</style>
